export default {
  panelDropShadow: 'box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.2);',
  componentSmallRadius: 'border-radius: 3px;'
};